import {api} from '../../../config';
import mixins from '../../../mixins';

export default {
    read: function() {
        return {
            url: api('API_LOGIN'),
            type: 'post',
            responseType: 'json',
            contentType: 'application/json',
            data: {
                request_ref: mixins.requestRefUuid(),
                sid: mixins.getCookie('skey'),
                data: {},
            },
        };
    },
};
